import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import BasicColumnChart from "../../../../../components/chart/BasicColumnChart";
import ReactTable from "../../../../../lib/table/react-table";
import SparlLineBar from "../../../../../components/chart/SparlLineBar";
import TableHeaderSwiper from "../components/TableHeaderSwiper";
import { useParams } from "react-router-dom";
import {
  useGetLandingPageCategory,
  useGetLandingPageCategoryReport,
  useGetLandingPageCategoryReportCtr,
  useGetLandingPageCategoryType,
  useGetSummaryCampaignGroupList,
} from "../../../../../queries/query-hooks/workspace/brand-ads-hook";
import {
  formatLocalizedDate,
  titleCase,
  transformGraphData,
} from "../../../../../common/utils/utils";
import SquareChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/square-chart-skeleton";
import BarChartSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/bar-chart-skeleton";
import CommonTableLoader from "../../../../../skeleton/common-table-loader";
import NavSwiperSkeleton from "../../../../../skeleton/workspace/clirnet/brand-ads/nav-swiper-skeleton";
import PageNotFound from "../../../../PageNotFound";
import { fallbackImages } from "../../../../../utilities/fallback-images";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import Skeleton from "../../../../../components/skeleton";
import useCsvDownloader from "../../../../../components/custom-hooks/use-csv-downloader";
import { GRAPH_FILL_COLOR } from "../constant/graph-color-scheme";
import PieChart from "../../../../../components/chart/PieChart";
import * as dayjs from "dayjs";
import { ProjectHeaderTopBar, TableHeader } from "@ui";
import ProjectFilters from "../components/ProjectFilters";
import { useDispatch, useSelector } from "react-redux";
import { selectProject } from "store/project/project.selector";
import { updateProject } from "store/project/project.action";
const DAYS_OF_WEEK = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function LandingPage() {
  const { project_id } = useParams();
  const dispatch = useDispatch();
  const project = useSelector(selectProject);
  const { downloadCSV } = useCsvDownloader();

  const handleTableCsvDownload = () => {
    downloadCSV(tableCsvFormat);
  };

  const [activeCampaignGroup, setActiveCampaignGroup] = useState({});

  function getGroupIdsCommaSeparated(data) {
    return data.map((item) => item.group_id).join(",");
  }

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [isProjectChange, setIsProjectChange] = useState(false);

  useEffect(() => {
    setIsProjectChange(true);
  }, [project_id]);

  const { data: landingPageCategory, isLoading: isLandingPageCategoryLoading } =
    useGetLandingPageCategory(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list:
          projectDetails && projectDetails?.length > 0
            ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
            : "",
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const {
    data: landingPageCategoryType,
    isLoading: isLandingPageCategoryTypeLoading,
  } = useGetLandingPageCategoryType(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const { data: landingPageReport, isLoading: isLandingPageReportLoading } =
    useGetLandingPageCategoryReport(
      project_id,
      {
        start_date: dateRangePayload.start_date,
        end_date: dateRangePayload.end_date,
        campaign_list: activeCampaignGroup?.id,
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const {
    data: landingPageReportCtr,
    isLoading: isLandingPageReportLoadingCtr,
  } = useGetLandingPageCategoryReportCtr(
    project_id,
    {
      start_date: dateRangePayload.start_date,
      end_date: dateRangePayload.end_date,
      campaign_list: activeCampaignGroup?.id,
    },
    !!dateRangePayload.start_date && !!dateRangePayload.end_date
  );

  const { data: campaignGroupList, isLoading: isCampaignGroupListLoading } =
    useGetSummaryCampaignGroupList(project_id, {
      campaign_list:
        projectDetails && projectDetails?.length > 0
          ? getGroupIdsCommaSeparated(projectDetails[0]?.project_group_data)
          : "",
    });

  const pageTypeChartOptions = {
    labels:
      landingPageCategoryType && landingPageCategoryType?.length > 0
        ? transformGraphData(
            landingPageCategoryType,
            "pct_count",
            "Landing_page_type",
            false
          )?.label
        : [],
    series:
      landingPageCategoryType && landingPageCategoryType?.length > 0
        ? transformGraphData(
            landingPageCategoryType,
            "pct_count",
            "Landing_page_type"
          )?.series
        : [],
  };

  const TableColumnData = [
    {
      Header: "Landing Page Type",
      columnId: 1,
      accessor: "Landing_page_type",
      disableFilters: true,
      Cell: ({ value }) => `${value ? titleCase(value, false) : "-"}`,
    },

    {
      Header: "Viewed",
      columnId: 3,
      accessor: "views",
      disableFilters: true,
      Cell: ({ value }) => `${value ? value : 0}`,
    },
    // {
    //   Header: "Mobile Impression",
    //   columnId: 4,
    //   accessor: "mobile_imp",
    //   disableFilters: true,
    //   Cell: ({ value }) => `${value ? value : 0}`,
    // },
    // {
    //   Header: "Web Impression",
    //   columnId: 5,
    //   accessor: "web_imp",
    //   disableFilters: true,
    //   Cell: ({ value }) => `${value ? value : 0}`,
    // },
    // {
    //   Header: "Total Impression",
    //   columnId: 6,
    //   accessor: "total_impr",
    //   disableFilters: true,
    //   Cell: ({ value }) => `${value ? value : 0}`,
    // },
    {
      Header: "Total CTR (%)",
      columnId: 7,
      accessor: "ctr",
      disableFilters: true,
      Cell: ({ value, row }) => {
        return value == "loading" ? (
          <Skeleton width={100} />
        ) : value ? (
          `${value} %`
        ) : (
          "0 %"
        );
      },
    },
    // {
    //   Header: "Trends",
    //   columnId: 8,
    //   accessor: "date_Data",
    //   disableFilters: true,
    //   Cell: ({ cell: { value } }) => {
    //     if (value && value.split(",")?.length > 0) {
    //       return (
    //         <SparlLineBar
    //           series={value?.split(",") || []}
    //           labels={DAYS_OF_WEEK}
    //           height={50}
    //         />
    //       );
    //     } else {
    //       return "N/A";
    //     }
    //   },
    // },
  ];
  const getCategories = (data) => {
    const categories = data?.map((item) => item?.Landing_page_type);
    const uniqueCategories = [...new Set(categories)];

    const colors = [
      "#13388c",
      "#159a6c",
      "#15607a",
      "#1d81a2",
      "#cecdcd",
      "#636E72",
    ];

    const series = uniqueCategories.map((item, index) => {
      const filteredData = data?.filter(
        (data) => data?.Landing_page_type == item
      );
      return {
        name: item,
        data:
          filteredData && filteredData?.length > 0
            ? transformGraphData(filteredData, "Count_value", "formatted_date")
                ?.series
            : [],
        color: colors[index],
      };
    });

    return series;
  };

  const pageCategoryChartOption = {
    series: getCategories(landingPageCategory),
    labels:
      landingPageCategory && landingPageCategory?.length > 0
        ? [
            ...new Set(
              transformGraphData(
                landingPageCategory,
                "Count_value",
                "formatted_date"
              )?.label
            ),
          ]
        : [],
  };

  function mergeLandingPageData(pageList, pageWiseCtr) {
    if (!pageWiseCtr && pageList?.length > 0) {
      return pageList.map((items) => ({
        ...items,
        unique_views: "loading",
        unique_clicks: "loading",
        ctr: "loading",
      }));
    } else if (
      pageList &&
      pageList?.length > 0 &&
      pageWiseCtr &&
      pageWiseCtr?.length > 0
    ) {
      const mergedData = pageList.map((items) => {
        const matchingMatrix = pageWiseCtr.find(
          (matrix) => matrix.Landing_page_type === items.Landing_page_type
        );
        return {
          ...(matchingMatrix || {}),
          ...items,
        };
      });
      return mergedData.sort((a, b) => b.views - a.views);
    } else {
      return pageList && Array.isArray(pageList)
        ? pageList.sort((a, b) => b.views - a.views)
        : pageList;
    }
  }

  const landingPageTableData = mergeLandingPageData(
    landingPageReport,
    landingPageReportCtr
  );

  const tableCsvFormat = {
    header: [
      "Landing page type",
      "views",
      "Total CTR (%)",
      // "mobile imp",
      // "web imp",
      // "total impr",
    ],
    column: [
      "Landing_page_type",
      "views",
      "ctr",
      // "mobile_imp",
      // "web_imp",
      // "total_impr",
    ],
    // chart: {
    //   header: "Trends",
    //   column: "date_Data",
    // },
    rows: landingPageTableData,
  };

  useEffect(() => {
    if (projectDetails && projectDetails?.length > 0) {
      const today = dayjs();
      const projectEndDate = dayjs(projectDetails[0]?.project_end_date);
      let result = projectDetails[0]?.project_end_date;

      if (
        projectEndDate &&
        (projectEndDate.isAfter(today) || projectEndDate.isSame(today, "day"))
      ) {
        result = today.subtract(1, "day");
      } else {
        result = projectEndDate;
      }

      if (project?.start_date && project?.end_date && !isProjectChange) {
        setDateRangePayload({
          start_date: project?.start_date,
          end_date: project?.end_date,
        });
        dispatch(
          updateProject({
            start_date: project?.start_date,
            end_date: project?.end_date,
          })
        );
      } else {
        setDateRangePayload({
          start_date: formatLocalizedDate(
            new Date(projectDetails[0]?.project_start_date),
            "YYYY-MM-DD[T]00:00:00.000Z"
          ),
          end_date: formatLocalizedDate(
            new Date(result),
            "YYYY-MM-DD[T]23:59:59.000Z"
          ),
        });
        dispatch(
          updateProject({
            start_date: formatLocalizedDate(
              new Date(projectDetails[0]?.project_start_date),
              "YYYY-MM-DD[T]00:00:00.000Z"
            ),
            end_date: formatLocalizedDate(
              new Date(result),
              "YYYY-MM-DD[T]23:59:59.000Z"
            ),
          })
        );
        setIsProjectChange(false);
      }
    }
  }, [projectDetails, project_id]);

  const allLandingPageDataLoaded =
    !isProjectDetailsLoading &&
    !isLandingPageCategoryTypeLoading &&
    !isLandingPageCategoryLoading;

  const landingPageCharts = [
    {
      key: "landingPageType",
      hasData: landingPageCategoryType?.length > 0,
      element: (
        <PieChart
          labels={pageTypeChartOptions.labels}
          series={pageTypeChartOptions.series}
          title="Impression by Landing Page Type"
          graphColor={GRAPH_FILL_COLOR}
          height={400}
          width={320}
        />
      ),
    },
    {
      key: "landingPageCategory",
      hasData: landingPageCategory?.length > 0,
      element: (
        <BasicColumnChart
          title="Impression by Landing Page Category"
          series={pageCategoryChartOption.series}
          labels={pageCategoryChartOption.labels}
        />
      ),
    },
  ].filter((chart) => chart.hasData);

  const colClassMap = {
    1: "col-12",
    2: {
      landingPageType: "col-md-4 col-sm-12 mb-4",
      landingPageCategory: "col-md-8 col-sm-12 mb-4",
    },
  };

  const getColClass = (key) => {
    if (landingPageCharts.length === 1) return "col-12 mb-4";
    return colClassMap[2][key];
  };

  return (
    <div className="row">
      <div className="col-sm-12">
        <ProjectHeaderTopBar
          projectType="Brand Ads"
          title="Landing Page"
          projectStartDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_start_date
              : ""
          }
          projectEndDate={
            projectDetails?.length > 0
              ? projectDetails[0]?.project_end_date
              : ""
          }
          isProjectDetailsLoading={isProjectDetailsLoading}
          rightComponent={
            <ProjectFilters
              title="Landing Page"
              dateLabel={dateRangePayload}
              setDateRangePayload={setDateRangePayload}
              projectStartDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_start_date
                  : ""
              }
              projectEndDate={
                projectDetails?.length > 0
                  ? projectDetails[0]?.project_end_date
                  : ""
              }
              isProjectDetailsLoading={isProjectDetailsLoading}
            />
          }
        />
      </div>

      {allLandingPageDataLoaded ? (
        landingPageCharts.length > 0 ? (
          <div className="col-sm-12">
            <div className="row">
              {landingPageCharts.map((chart) => (
                <div key={chart.key} className={getColClass(chart.key)}>
                  {chart.element}
                </div>
              ))}
            </div>
          </div>
        ) : null
      ) : (
        <div className="row">
          <div className="col-md-4 col-sm-12 mb-4">
            <SquareChartSkeleton />
          </div>
          <div className="col-md-8 col-sm-12 mb-4">
            <BarChartSkeleton />
          </div>
        </div>
      )}

      <div className="col-sm-12">
        <Card>
          <TableHeader
            title="Landing page"
            downloadProps={{
              needCsvDownload:
                !isLandingPageReportLoading && landingPageReport?.length > 0,
              exportCSVHandler: handleTableCsvDownload,
            }}
          />

          {!isCampaignGroupListLoading && campaignGroupList.length > 0 ? (
            <div className="px-md-4 px-3">
              <TableHeaderSwiper
                className={"me-0 mt-4"}
                title={campaignGroupList}
                activeCampaignGroup={activeCampaignGroup}
                setActiveCampaignGroup={setActiveCampaignGroup}
              />
            </div>
          ) : (
            <div className="px-md-4 px-3">
              <NavSwiperSkeleton />
            </div>
          )}
          <Card.Body>
            {!isProjectDetailsLoading &&
            !isLandingPageReportLoading &&
            landingPageReport?.length > 0 ? (
              <ReactTable
                data={landingPageTableData}
                columns={TableColumnData}
                isPaginationShow={false}
                noDataText="no data"
                noDataImage={fallbackImages.noActionData}
              />
            ) : isLandingPageReportLoading || isProjectDetailsLoading ? (
              <CommonTableLoader tableRowLength={5} />
            ) : null}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

export default LandingPage;
